module.exports = __webpack_public_path__ + "img/smart-logo-new.c6512d8c.svg";